export enum EReportingPaymentsColumnKeys {
  Amount = 'amount',
  AssetCode = 'asset_code',
  AssetIssuer = 'asset_issuer',
  CreatedAt = 'created_at',
  DeletedAt = 'deleted_at',
  Guid = 'guid',
  ReceiverID = 'receiver_id',
  SenderID = 'sender_id',
  Status = 'status',
  UpdatedAt = 'updated_at',
  Fee = 'fee',
  SenderCounterparty = 'sender_counterparty',
  ReceiverCounterparty = 'receiver_counterparty',
  ReceiverAccountKind = 'receiver_account_account_kind',
  SenderAccountKind = 'sender_account_account_kind',
  Details = 'details',
}

export enum EReportingEmissionFilterKeys {
  Counterparty = 'counterparty_guid',
  EmissionAccount = 'emission_account_guid',
  IssuerPayment = 'issuer_payment_guid',
  EmissionPayment = 'emission_payment_guid',
  Status = 'status',
  AmountMin = 'min_requested_amount',
  AmountMax = 'max_requested_amount',
  CreatedAtMin = 'min_created_at',
  CreatedAtMax = 'max_created_at',
  AssetGUID = 'asset_guid',
  AssetIssuer = 'asset_issuer_guid',
}

export enum EReportingEmissionFilterFormKeys {
  Counterparty = 'counterparty_guid',
  EmissionAccount = 'emission_account_guid',
  Status = 'status',
  Direction = 'direction',
  AmountMin = 'min_requested_amount',
  AmountMax = 'max_requested_amount',
  CreatedAt = 'created_at',
  AssetGUID = 'asset_guid',
  AssetIssuer = 'asset_issuer_guid',
}

export enum EReportingPaymentsQueryParams {
  Page = 'page',
  PageSize = 'pageSize',
}
